import React from 'react'
import classnames from 'classnames'

import styles from './styles.css'

const AddItemModal = ({
  inputValue,
  inputOnChange,
  inputPlaceholder,
  inputKeyPress,
  button1Name,
  button2Name,
  button1Function,
  button2Function,
}) => (
  <div className={classnames(styles.form)}>
    <input
      className={classnames(styles.input)}
      type="text"
      placeholder={inputPlaceholder}
      value={inputValue}
      onChange={inputOnChange}
      onKeyPress={inputKeyPress}
      autoFocus="true"
    />
    <div>
      <button className={classnames(styles.button)} onClick={button1Function}>
        {button1Name}
      </button>
      <button className={classnames(styles.button)} onClick={button2Function}>
        {button2Name}
      </button>
    </div>
  </div>
)

export default AddItemModal



// WEBPACK FOOTER //
// ./src/views/today-items/add-item-modal/index.js